import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoleDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class RoleApiClient extends BaseCRUDApiClient<RoleDto> {
  baseUrl = this.config.apiEndpoint + '/role';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
